import React from 'react';
import {
  List,
  Create,
  SimpleForm,
  BooleanInput,
  RadioButtonGroupInput,
  translate as t,
  TextInput,
  ReferenceArrayInput,
  SelectInput,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import SortableList from '../components/SortableList';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import ImageInput from '../components/inputs/ImageInput';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';
import SelectArrayInput from '../components/inputs/SelectArrayInput';

export const CategoryList = (props) => (
  <List {...props} pagination={null} perPage={10000}>
    <SortableList
      {...props}
      editButton={<EditButton {...props} basePath="/categories" />}
      deleteButton={<DeleteButton {...props} basePath="/categories" />}
    />
  </List>
);

const CategoryTitle = t(({ record, translate, locale }) => (
  <span>
    {record ? translate('edit.title', { title: getTranslationByLocale(record.title, locale) }) : ''}
  </span>
));

const Label = t(({ label, translate }) => <span> {label ? translate(label) : ''} </span>);

const mainCategories = [
  { id: 'food', name: 'food' },
  { id: 'drink', name: 'drink' },
];

const Form = t((props) => (
  <SimpleForm redirect="list" {...props}>
    <RadioButtonGroupInput source="mainCategory" choices={mainCategories} />
    <BooleanInput source="promotion" />

    <ReferenceArrayInput
      {...props}
      source="markets"
      label={<Label label="selectMarket" />}
      reference="markets"
      allowEmpty
    >
      <SelectArrayInput optionText="countryCode" />
    </ReferenceArrayInput>

    <TranslatableInput source="title" />
    <TranslatableInput source="subtitle" />
    <TranslatableInput source="description" />

    <TextInput source="icon" />
    <TextInput source="headerUrl" />
    <SelectInput
      source="scrollDirection"
      choices={[
        { id: 'horizontal', name: props.translate('resources.categories.horizontal') },
        { id: 'vertical', name: props.translate('resources.categories.vertical') },
      ]}
    />

    <BooleanInput source="alcoholic" />
    <ImageInput source="mainImageUrl" accept="image/*">
      <ThumbnailImageField source="src" />
    </ImageInput>
  </SimpleForm>
));

export const CategoryEdit = (props) => (
  <Edit title={<CategoryTitle />} {...props}>
    <Form {...props} />
  </Edit>
);

export const CategoryCreate = (props) => (
  <Create {...props}>
    <Form {...props} />
  </Create>
);
